import '../styles/Contact.css';
import { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, company, message } = formData;
    const subject = encodeURIComponent(`Consultation Request from ${name}${company ? ` (${company})` : ''}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}${company ? `\nCompany: ${company}` : ''}\n\nMessage:\n${message}`
    );
    window.location.href = `mailto:ckgroupofcompaniesltd@gmail.com?subject=${subject}&body=${body}`;
    setFormData({ name: '', email: '', company: '', message: '' });
  };

  return (
    <div className="contact">
      {/* Header */}
      <section className="contact-header">
        <div className="contact-header-overlay"></div>
        <div className="contact-header-content">
          <h1>Get in Touch</h1>
          <p>Let's discuss how we can help transform your organization</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="contact-container">
          {/* Form */}
          <div className="contact-form-section">
            <h2>Send us a Message</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your company"
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about your challenge..."
                  rows="6"
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>

          {/* Contact Info with image */}
          <div className="contact-info-section">
            <div className="contact-office-image">
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=350&fit=crop"
                alt="CK Innovation office"
                className="office-img"
              />
            </div>
            <h2>Contact Information</h2>
            <div className="info-item">
              <h4>Address</h4>
              <p>United Kingdom</p>
              <p>
                <a href="mailto:ckgroupofcompaniesltd@gmail.com">ckgroupofcompaniesltd@gmail.com</a>
              </p>
              <p>
                <a href="tel:+447427083110">+44 7427 083110</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Map / Location Image */}
      <section className="contact-map-section">
        <img
          src="https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1400&h=400&fit=crop"
          alt="London skyline"
          className="contact-map-img"
        />
        <div className="contact-map-overlay">
          <p>Based in London, serving clients across the UK & Europe</p>
        </div>
      </section>
    </div>
  );
}

export default Contact;
